import React, { useCallback } from 'react'
import { Trans } from 'gatsby-plugin-react-i18next'
import { Badge } from 'react-bootstrap'

interface BadegsProps {
  payment?: boolean
  approval?: boolean
  pill?: boolean
  status: string
}

const CustomBadeg = ({
  status,
  payment = false,
  approval = false,
  pill = false,
}: BadegsProps): JSX.Element => {
  const getPaymentStatusBgColor = (status: string) => {
    if (status === 'WAIT') {
      return 'danger'
    } else if (status === 'COMPLETE') {
      return 'success'
    } else if (status === 'FAILURE') {
      return 'danger'
    }
  }

  const getApprovalBgColor = (approval: string) => {
    if (approval === 'PENDING') return 'info'
    else if (approval === 'DISAPPROVED') return 'danger'
    else if (approval === 'CANCELED') return 'warning'
    else return 'success'
  }

  const getColor = useCallback(
    (status: string) => {
      if (payment) return getPaymentStatusBgColor(status)
      else if (approval) return getApprovalBgColor(status)
    },
    [payment, approval]
  )

  return (
    <Badge bg={getColor(status)} pill={pill}>
      <Trans>{`share.${status}`}</Trans>
    </Badge>
  )
}

export default CustomBadeg
